module.exports = __webpack_public_path__ + "img/gate-horizontal.122fa5fb.png";